// React Redux
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "@/features/auth/authThunks";
import { getPublicEventosInfo } from "@/features/publicEventos/publicEventosThunks";
import { getMisTicketsComprados } from "@/features/user/userThunks";
import { fetchUnreadCount } from "@/features/notificacion/notificacionThunks";
import { formatFechaHoraEvento } from "@/lib/utilsUI";
import { parseUTCDate, DEFAULT_TIMEZONE } from "@/utils/dateHelpers";

// React Utils
import { useState, useCallback, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
// Utilities
import { Link } from "react-router-dom";
// Assets
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import AppWhoppLogo from "@/assets/appwhoop_ticket_logo.webp";
import EventImage1 from "@/assets/eventos/ViejasDeMierda.webp";
import EventImage2 from "@/assets/eventos/ClubAmandaDJCeleArrabal.webp";
import EventImage3 from "@/assets/eventos/ClubAmandaFullBailableYElectronic.webp";
import EventImage4 from "@/assets/eventos/CelebrarEnAlonso.webp";
import EventImage5 from "@/assets/eventos/Ferxxo.webp";
import EventImage6 from "@/assets/eventos/JorisVoorn.webp";
import genericUserImage from "@/assets/avatars/avatar-generic.webp";
// components
import Modal from "@/components/Modals/Modal";
import SignIn from "@/components/Forms/SignIn";
import Register from "@/components/Forms/Register";
import LocationSearch from "./LocationSearch";
import CartModal from "@/components/Modals/CartModal";
import NotificationModal from "@/components/Modals/NotificationModal";
import TicketsModal from "@/components/Modals/TicketsModal";
import PaymentModal from "@/components/Modals/PaymentCartModal";
import PaySuccessModal from "@/components/Modals/PaymentCartModal/PaySuccessModal";
import PayFailModal from "@/components/Modals/PaymentCartModal/PayFailModal";
import DropdownMenu from "@/components/DropdownMenu";
// Forms
import InvitarAmigos from "@/components/Forms/InvitarAmigos";

// Contextos
import { useModalsContext } from "@/contexts/ModalsContext";
// Cart context
import { useCart } from "@/contexts/CartContext";

// Toast
import { useToast, ToastContainer } from "@/components/ui/Toast";

// Información de localizaciones (ejemplo)
const localidades = [
  "Ciudad de Guatemala",
  "Antigua Guatemala",
  "Quetzaltenango",
  "Escuintla",
  "Petén",
  "Huehuetenango",
  "Chiquimula",
  "Santa Rosa",
  "Retalhuleu",
  "Izabal",
  "Alta Verapaz",
  "Baja Verapaz",
  "Suchitepéquez",
  "Totonicapán",
  "Ciudad de Guatemala",
  "Antigua Guatemala",
  "Quetzaltenango",
  "Escuintla",
  "Petén",
  "Huehuetenango",
  "Chiquimula",
  "Santa Rosa",
  "Retalhuleu",
  "Izabal",
  "Alta Verapaz",
  "Baja Verapaz",
  "Suchitepéquez",
  "Totonicapán",
  "Ciudad de Guatemala",
  "Antigua Guatemala",
  "Quetzaltenango",
  "Escuintla",
  "Petén",
  "Huehuetenango",
  "Chiquimula",
  "Santa Rosa",
  "Retalhuleu",
  "Izabal",
  "Alta Verapaz",
  "Baja Verapaz",
  "Suchitepéquez",
  "Totonicapán",
  "Ciudad de Guatemala",
  "Antigua Guatemala",
  "Quetzaltenango",
  "Escuintla",
  "Petén",
  "Huehuetenango",
  "Chiquimula",
  "Santa Rosa",
  "Retalhuleu",
  "Izabal",
  "Alta Verapaz",
  "Baja Verapaz",
  "Suchitepéquez",
  "Totonicapán",
];

export default function Header({ onSidebarToggle }) {
  // Redux dispatch
  const dispatch = useDispatch();
  // Redux state for authentication
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const unreadCount = useSelector((state) => state.notificacion?.unreadCount || 0);

  // React utilities
  const location = useLocation();
  
  // Fetch unread count on mount and location change
  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchUnreadCount());
    }
  }, [isAuthenticated, location.pathname, dispatch]);
  
  // Cart context
  const { carts, isCartModalOpen, openCartModal, closeCartModal } = useCart();
  // Contextos
  const { modals, openModal, closeModal } = useModalsContext();
  // Toast
  const { toasts, removeToast } = useToast();

  const [mobileSearchActive, setMobileSearchActive] = useState(false);
  const [showSelectLocation, setShowSelectLocation] = useState(false);
  const [isOpenCart, setIsOpenCart] = useState(false);
  const [isOpenTicketsModal, setIsOpenTicketsModal] = useState(false);
  const [isOpenNotify, setIsOpenNotify] = useState(false);
  const [isOpenPayment, setIsOpenPayment] = useState(false);
  const [selectedCarritoUid, setSelectedCarritoUid] = useState(null);
  const [selectedKlapOrderId, setSelectedKlapOrderId] = useState(null); // Estado para klapOrderId
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isFailOpen, setIsFailOpen] = useState(false);

  // 🔍 Estado para búsqueda de eventos
  const [searchQuery, setSearchQuery] = useState("");
  const searchTimeoutRef = useRef(null);

  // 🎫 Estados para tickets del modal
  const [ticketsForModal, setTicketsForModal] = useState([]);
  const [ticketsLoading, setTicketsLoading] = useState(false);
  const [ticketsPage, setTicketsPage] = useState(1);
  const [hasMoreTickets, setHasMoreTickets] = useState(false);

  console.log("isOpenPayment:", isOpenPayment);

  // 🔍 Debounced search: Solo buscar después de 500ms sin escribir
  useEffect(() => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      const now = new Date().toISOString();
      const farPast = '1970-01-01T00:00:00.000Z';
      
      if (searchQuery.trim()) {
        // Buscar eventos por nombre (mantener filtros del Home)
        dispatch(
          getPublicEventosInfo({
            nombre: searchQuery,
            page: 1,
            limit: 10,
            fechaHoraInicioDesde: farPast,  // Allow started events
            fechaHoraFinDesde: now          // Only show events that haven't ended
          }),
        );
      } else if (searchQuery === "") {
        // Si se borra la búsqueda, cargar eventos normales (con filtros del Home)
        dispatch(
          getPublicEventosInfo({
            page: 1,
            limit: 10,
            fechaHoraInicioDesde: farPast,  // Allow started events
            fechaHoraFinDesde: now          // Only show events that haven't ended
          }),
        );
      }
    }, 500);

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchQuery, dispatch]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Función para manejar la selección de ubicación
  const handleSelect = (localidad) => {
    setShowSelectLocation(false);
    console.log("Seleccionaste:", localidad);
  };

  // 🎫 Función para formatear tickets al formato del modal
  const formatTicketsForModal = (ticketsComprados) => {
    return ticketsComprados.flatMap((grupo) =>
      grupo.tickets.map((ticket) => ({
        id: ticket.id,
        uid: ticket.uid,
        type: "bought",
        title: grupo.evento.nombre,
        subtitle: `Ticket: ${ticket.tipoTicket?.nombre || "Sin tipo"}`,
        img: ticket.tipoTicketImg || ticket.eventoImg || grupo.evento.img,
        time: formatFechaHoraEvento(
          parseUTCDate(
            grupo.evento.fechaHoraInicio,
            grupo.evento.zonaHoraria || DEFAULT_TIMEZONE,
          )?.toJSDate(),
          grupo.evento.zonaHoraria || DEFAULT_TIMEZONE,
        ),
        seats: ticket.numeroTributario,
        eventoUid: grupo.evento.uid,
        vigente: ticket.vigente,
        fechaHoraInicio: grupo.evento.fechaHoraInicio,
      })),
    );
  };

  // 🎫 Función para cargar tickets próximos
  const loadTickets = async (page = 1, append = false) => {
    if (!isAuthenticated || ticketsLoading) return;

    setTicketsLoading(true);
    try {
      const now = new Date().toISOString();
      const response = await dispatch(
        getMisTicketsComprados({
          vigente: true,
          eventoFechaHoraInicioDesde: now,
          sortBy: "eventoFechaHoraInicio",
          sortOrder: "asc",
          page: page,
          limit: 10,
        }),
      ).unwrap();

      console.log("🎫 Respuesta completa:", response);
      console.log("🎫 Tickets array:", response.tickets);
      console.log("🎫 Pagination:", response.pagination);

      const formattedTickets = formatTicketsForModal(response.tickets || []);
      console.log("🎫 Tickets formateados:", formattedTickets);
      console.log(
        "🎫 Cantidad de tickets formateados:",
        formattedTickets.length,
      );

      if (append) {
        setTicketsForModal((prev) => [...prev, ...formattedTickets]);
      } else {
        setTicketsForModal(formattedTickets);
      }

      setTicketsPage(page);
      setHasMoreTickets(response.pagination?.hasNextPage || false);
      console.log("🎫 hasMoreTickets:", response.pagination?.hasNextPage);
    } catch (error) {
      console.error("❌ Error loading tickets:", error);
    } finally {
      setTicketsLoading(false);
    }
  };

  // 🎫 Función para cargar más tickets
  const loadMoreTickets = () => {
    if (hasMoreTickets && !ticketsLoading) {
      loadTickets(ticketsPage + 1, true);
    }
  };

  // 🎫 Función para manejar apertura del modal de tickets
  const handleOpenTicketsModal = () => {
    console.log("🎫 Abriendo modal de tickets...");
    console.log("🎫 isAuthenticated:", isAuthenticated);
    console.log("🎫 ticketsLoading:", ticketsLoading);

    setIsOpenTicketsModal(true);
    
    // Siempre cargar tickets al abrir el modal
    if (!ticketsLoading && isAuthenticated) {
      console.log("🎫 Iniciando carga de tickets...");
      // Reiniciar estado antes de cargar
      setTicketsForModal([]);
      setTicketsPage(1);
      setHasMoreTickets(false);
      loadTickets(1, false);
    } else {
      console.log("🎫 No se pueden cargar tickets - loading en proceso o usuario no autenticado");
    }
  };

  const menuOptions = [
    {
      type: "none",
      classContent: "bg-aw-bluedark p-1.5",
    },
    {
      type: "link",
      label: "Perfil",
      icon: "fa-solid fa-user",
      to: `/perfil/${user?.uid}`,
      className: "text-white hover:bg-aw-green/20",
    },
    // {
    //   type: "button",
    //   label: "Invitar Amigos",
    //   icon: "fa-solid fa-user-plus",
    //   onClick: () => openModal("invitarAmigos"),
    //   className: "text-white hover:bg-aw-green/20",
    // },
    {
      type: "link",
      label: "Crear una Empresa",
      icon: "fa-solid fa-building",
      to: "/empresa/crear",
      className: "text-white hover:bg-aw-green/20",
    },
    {
      type: "button",
      label: "Cerrar Sesión",
      icon: "fa-solid fa-right-from-bracket",
      onClick: () => dispatch(logoutUser()),
      className: "text-white hover:bg-aw-green/20",
    },
  ];

  return (
    <>
      <div className="relative flex flex-row justify-between sm:justify-evenly lg:justify-between items-center h-16 sm:h-28 bg-aw-bluedark-50 text-white px-4 py-2">
        {/* Icono de menú lateral */}
        <div>
          <button
            className="text-neutral-200 pr-3 lg:px-3"
            onClick={onSidebarToggle}
          >
            <FontAwesomeIcon icon="fa-solid fa-bars" />
          </button>
        </div>

        {/* Logo */}
        <div
          className={`${
            mobileSearchActive ? "w-0 h-8" : "h-8 w-5/12 sm:w-1/5 lg:w-2/5"
          } duration-300 transition-width`}
        >
          <LazyLoadImage
            alt="AppWhoop Logo"
            effect="blur"
            wrapperProps={{
              style: { transitionDelay: "0.3s" },
            }}
            onClick={() => window.location.href = "/"}
            src={AppWhoppLogo}
            className="w-full sm:w-44 h-auto object-contain cursor-pointer"
          />
        </div>
        {/* <div className="lg:w-1/6"></div> */}

        {/* Icono de busqueda */}
        {location.pathname === "/" ? (
        <div className={`sm:hidden duration-300 transition-opacity`}>
          <button className="text-neutral-200">
            {/* Icono cambiante en móviles para la acción del buscador x y lupa */}
            <FontAwesomeIcon
              icon={`fa-solid ${mobileSearchActive ? "fa-xmark" : "fa-search"}`}
              onClick={() => setMobileSearchActive(!mobileSearchActive)}
            />
          </button>
        </div>
        ): <div className={`sm:hidden duration-300 transition-opacity`}>
          <FontAwesomeIcon icon="fa-solid fa-arrow-left" onClick={() => window.history.back()} className="text-neutral-200 cursor-pointer" />
          </div>}

        {/* Acciones de busqueda */}
        {location.pathname === "/" && (
          <div
            className={`flex items-center space-x-4 w-9/12 sm:w-5/12 lg:w-3/12 xl:w-2/12 duration-300 transition-right transition-left transition-width ${
              window.innerWidth <= 640
                ? mobileSearchActive
                  ? "absolute top-0 bottom-0 my-auto left-12"
                  : "absolute top-0 bottom-0 my-auto -left-full overflow-hidden"
                : ""
            }`}
          >
            <div className="relative w-full">
              <div
                className={`absolute flex items-center space-x-4 w-10/12 h-2/3 top-1/6 left-10 bg-aw-bluedark duration-300 transition-scale transition-width rounded-2xl p-1 z-[100] ${
                  showSelectLocation ? "scale-100 my-auto" : "scale-0"
                }`}
              >
                {/* <LocationSearch
                  locations={localidades}
                  onSelect={handleSelect}
                /> */}
              </div>
              {/* input with lateral left search icon */}
              <div className="relative w-full">
                <FontAwesomeIcon
                  icon="fa-solid fa-location-dot"
                  className="absolute left-1.5 top-1/2 transform -translate-y-1/2 text-red-500 p-3"
                  // onClick={() => setShowSelectLocation(!showSelectLocation)}
                />
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  placeholder="Qué estás buscando hoy..."
                  className="pl-10 pr-4 py-2 my-2 bg-aw-bluedark border border-aw-bluegray rounded-full focus:outline-none focus:ring-2 focus:ring-aw-bluegray placeholder:text-xs placeholder-gray-400 w-full"
                />
                <FontAwesomeIcon
                  icon="fa-solid fa-magnifying-glass"
                  className={`absolute right-3 top-1/2 ${
                    showSelectLocation ? "scale-0" : "scale-100"
                  } transform -translate-y-1/2 text-neutral-200`}
                />
              </div>
            </div>
          </div>
        )}
        {/* Acciones de usuario: Iniciar Sesión / Registrarse / Perfil */}
        {!isAuthenticated ? (
          <div className="hidden sm:flex items-center justify-end w-1/6">
            <button
              onClick={() => openModal("register")}
              className="w-6/12 bg-aw-bluedark text-white border border-aw-bluegray px-4 py-2 rounded-r-4xl rounded-tl-4xl rounded-bl-md font-medium transition-scale duration-200 hover:scale-95 hidden xl:inline-block"
            >
              Registrarse
            </button>
          </div>
        ) : (
          <div className="hidden sm:flex space-x-4 items-center">
            {/* Actividad Reciente */}
            <div className="relative">
              <FontAwesomeIcon
                onClick={() => setIsOpenNotify(true)}
                icon="fa-solid fa-bell"
                className="text-lg bg-aw-bluedark border border-aw-bluegray/75 rounded-lg py-2 px-3 cursor-pointer"
              />
              {unreadCount > 0 && (
                <div className="absolute -top-1 -right-1.5 w-5 h-5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
                  {unreadCount > 99 ? '99+' : unreadCount}
                </div>
              )}
            </div>
            <NotificationModal
              isOpen={isOpenNotify}
              onClose={() => setIsOpenNotify(false)}
            />
            {/* Mis Tickets */}
            <div className="text-sm bg-aw-bluedark border border-aw-bluegray/75 rounded-lg py-2 px-3 cursor-pointer">
              <FontAwesomeIcon
                onClick={handleOpenTicketsModal}
                icon="fa-solid fa-ticket"
                className=" -rotate-45"
              />
            </div>
            <TicketsModal
              isOpen={isOpenTicketsModal}
              onClose={() => setIsOpenTicketsModal(false)}
              tickets={ticketsForModal}
              isLoading={ticketsLoading}
              hasMore={hasMoreTickets}
              onLoadMore={loadMoreTickets}
            />
            {/* Carrito de Compras */}
            <div>
              <FontAwesomeIcon
                onClick={() => openCartModal()}
                icon="fa-solid fa-cart-shopping"
                className="text-lg bg-aw-bluedark border border-aw-bluegray/75 rounded-lg py-2 px-3 cursor-pointer"
              />
            </div>

            <CartModal
              isOpen={isCartModalOpen}
              onClose={closeCartModal}
              carts={carts}
              onOpenPayment={(carritoUid, klapOrderId) => {
                // Recibe carritoUid y klapOrderId desde CartSummary
                setSelectedCarritoUid(carritoUid);
                setSelectedKlapOrderId(klapOrderId);
                // setIsOpenPayment(true);
              }}
            />
            {/* {isOpenPayment == true && (
              <PaymentModal
                isOpen={isOpenPayment}
                onClose={() => setIsOpenPayment(false)}
                onBack={openCartModal}
                openSuccessModal={() => {
                  // Close payment modal
                  setIsOpenPayment(false);
                  // Close Cart modal
                  closeCartModal();
                  // Open success modal
                  setIsSuccessOpen(true);
                }}
                openFailModal={() => {
                  // Close payment modal
                  setIsOpenPayment(false);
                  // Close Cart modal
                  closeCartModal();
                  // Open fail modal
                  setIsFailOpen(true);
                }}
                carritoUid={selectedCarritoUid}
                klapOrderId={selectedKlapOrderId}
              />
            )}
            <PaySuccessModal
              isOpen={isSuccessOpen}
              onClose={() => setIsSuccessOpen(false)}
            />
            <PayFailModal
              isOpen={isFailOpen}
              onClose={() => setIsFailOpen(false)}
            /> */}
          </div>
        )}

        {/* Acciones de perfil */}
        {!isAuthenticated && (
          <div className="hidden sm:flex items-center space-x-2">
            <button
              onClick={() => openModal("signIn")}
              className="bg-white text-black px-6 py-2 rounded-r-4xl rounded-tl-4xl rounded-bl-md font-medium transition-scale duration-200 hover:scale-95 hidden xl:inline-block"
            >
              Iniciar Sesión
            </button>
            {/* <Link
              to={"/como-funciona"}
              className="bg-aw-green text-black font-medium px-4 py-2 rounded ml-2 rounded-r-4xl rounded-tl-4xl rounded-bl-md transition-scale duration-200 hover:scale-95 hidden xl:inline-block"
            >
              ¿Cómo Funciona?
            </Link> */}

            <button
              onClick={() => openModal("signIn")}
              className="bg-white text-black px-4 py-2 rounded-r-4xl rounded-tl-4xl rounded-bl-md font-medium transition-scale duration-200 hover:scale-95 xl:hidden"
            >
              <FontAwesomeIcon icon="fa-solid fa-user" />
            </button>
            <Link
              to={"/como-funciona"}
              className="bg-aw-green text-black font-medium px-4 py-2 rounded rounded-r-4xl rounded-tl-4xl rounded-bl-md transition-scale duration-200 hover:scale-95 xl:hidden"
            >
              <FontAwesomeIcon icon="fa-solid fa-circle-question" />
            </Link>
          </div>
        )}
        {isAuthenticated && (
          // if user is logged show img and name and a dropdown menu(options: perfil, logout) --> Use <DropdownMenu />
          // <DropdownMenu
          //   trigger={
          //     <button className="bg-transparent border border-white text-white font-semibold rounded-lg px-6 py-2 hover:bg-aw-green hover:text-aw-bluedark transition">
          //       <FontAwesomeIcon icon={"fa-solid fa-ellipsis"} />
          //     </button>
          //   }
          //   options={menuOptions}
          //   direction="down"
          //   align="end"
          //   classContent={menuOptions[0]?.classContent || "white"}
          // />
          <div className="hidden sm:flex items-center space-x-2">
            <DropdownMenu
              trigger={
                <div className="flex items-center space-x-2 cursor-pointer">
                  <LazyLoadImage
                    alt={user?.nombre + " " + user?.apellido}
                    effect="blur"
                    wrapperProps={{
                      style: { transitionDelay: "0.3s" },
                    }}
                    src={
                      user?.imgPerfil != null
                        ? user?.imgPerfil
                        : genericUserImage
                    }
                    className="w-10 h-10 rounded-full object-cover border-2 border-aw-green"
                  />
                  <span className="text-white line-clamp-1 max-w-44">
                    {user?.nombre + " " + user?.apellido}
                  </span>
                </div>
              }
              options={menuOptions}
              direction="down"
              align="end"
              classContent={menuOptions[0]?.classContent || "white"}
            />
          </div>
        )}
      </div>
      {modals.invitarAmigos && (
        <Modal
          isOpen={modals.invitarAmigos}
          onClose={() => closeModal("invitarAmigos")}
          large="max-w-4xl sm:max-w-3xl xl:max-w-5xl"
        >
          <InvitarAmigos closeInvitarAmigos={closeModal} />
        </Modal>
      )}

      {/* Toast Container */}
      <ToastContainer toasts={toasts} onRemove={removeToast} />
    </>
  );
}
